import {
	AutocompleteInput,
	BooleanInput,
	Create,
	ReferenceInput,
	required,
	SimpleForm,
	TextInput,
} from "react-admin";

export const PartnerCreate = () => (
	<Create>
		<SimpleForm>
			<TextInput source="name" validate={required()} fullWidth />
			<ReferenceInput source="ownerId" reference="users">
				<AutocompleteInput
					optionText="email"
					validate={required()}
					label="Owner"
					filterToQuery={(q) => ({ email: q })}
				/>
			</ReferenceInput>
			<BooleanInput
				source="payoutEnabled"
				label="Payout Enabled"
				defaultValue={false}
			/>
		</SimpleForm>
	</Create>
);
